export default "__VITE_ASSET__DDnKDKOl__"